import { useVendors } from '@/composables/app/useVendors'

export default attrs => {
  const { getVendorByUrl, getVendorUrl } = useVendors()

  const { type, input, textAlign = 'center' } = attrs

  if (!input) return {}

  if (type === 'video') {
    const vendor = getVendorByUrl(input)
    const src = getVendorUrl({ src: input })

    if (!src) return {}

    return {
      ...attrs,
      src,
      textAlign,
      width: 630,
      height: 354,
      ...vendor.attributes
    }

  } else {
    const parser = new DOMParser()
    const iframe = parser.parseFromString(input, 'text/html').querySelector('iframe')

    if (!iframe) return {}

    return {
      ...attrs,
      src: iframe.getAttribute('src'),
      width: iframe.getAttribute('width') || 630,
      height: iframe.getAttribute('height') || 354,
      frameborder: iframe.getAttribute('frameborder') || 0,
      allowfullscreen: iframe.getAttribute('allowfullscreen') || false,
      allow: iframe.getAttribute('allow')
    }
  }
}